export default () => {
  return {
    getLineLink: (lineId: string): string => {
      return `https://line.me/R/ti/p/${lineId}`
    },
    getFacebookLink: (id: string): string => {
      return `https://fb.me/${id}`
    },
    getMessengerLink: (id: string): string => {
      return `https://m.me/${id}`
    },
    getInstagramLink: (id: string): string => {
      return `https://www.instagram.com/${id}`
    },
    getWhatsAppLink: (id: string): string => {
      return `https://wa.me/${id}`
    },
  }
}
